import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getConsent, setConsent } from "@/lib/consent";
import { loadGtmIfConsented } from "@/lib/analytics";

export function CookieBanner() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const internalSurface =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/manual-scrape");

  useEffect(() => {
    setVisible(getConsent() === null);
    const onChange = () => setVisible(getConsent() === null);
    window.addEventListener("reputely-consent-change", onChange);
    return () => window.removeEventListener("reputely-consent-change", onChange);
  }, []);

  if (!visible || internalSurface) return null;

  function onAccept() {
    setConsent("granted");
    loadGtmIfConsented();
    setVisible(false);
  }

  function onDecline() {
    setConsent("denied");
    setVisible(false);
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6">
      <div className="mx-auto max-w-3xl rounded-xl border border-slate-200 bg-white p-4 shadow-lg ring-1 ring-slate-900/5 sm:flex sm:items-center sm:justify-between sm:gap-4 sm:p-5">
        <p className="text-sm text-slate-700">
          We use cookies to understand how visitors use this site and to improve
          the product. See our{" "}
          <Link to="/privacy" className="underline hover:text-slate-900">
            privacy policy
          </Link>
          .
        </p>
        <div className="mt-3 flex shrink-0 gap-2 sm:mt-0">
          <button
            type="button"
            onClick={onDecline}
            className="inline-flex items-center rounded-full border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="inline-flex items-center rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
